//import authApi from "@/api/authApi"

// export const myAction = async ({ commit }) => {
// }


// export const createUser = async ({ commit }, user) => {

//     const { nombre, usuario, correo, password, perfil } = user 

//     try {
//         const { data } = await authApi.post('usersmv/add_user/',{ nombre ,usuario, password, correo, perfil})
//         console.log( data)

//         // TODO : Mutation

//         return { ok: true }
        
//     } catch (error) {
//         console.log( error)
//         return { ok: false , message: error.response}
        
//     }

// }
import Swal from 'sweetalert2'

export const singInUser = async ({ commit }, user) => {

    //const { usuario, password } = user 

    try {


        // const options = {
        //     method: 'POST',
        //     body: JSON.stringify( user ),    
        //     headers: {
        //       "Content-type": "application/x-www-form-urlencoded",
        //     }  
        // };
        // console.log(user.usuario)
        // console.log(user.password)
        // usuario : 'CJ900024874',
        // password : 'abc123'
        //const resp = await fetch("https://conexmetsclm.com/sclm/login", options)
               //const resp = await fetch("https://conexmetsclm.com/sclm/login", requestOptions)
               //fetch("https://conexmetsclm.com/sclm/add-user", requestOptions)
                // .then(response => response.text())
                // .then(result => console.log(result))
                // .catch(error => console.log('error', error));
            // .then(response =>
            //         response.json().then(data => ({
            //         data: data,
            //         status: response.status
            //         })
            //         )
            // );

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        const urlencoded = new URLSearchParams();
        urlencoded.append("usuario", user.usuario);
        urlencoded.append("password", user.password);


        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            //body: urlencoded,
            body : JSON.stringify({ "usuario": user.usuario,
                    "password": user.password
                    }),
            redirect: 'follow'
        };

        //https://conexmetsclm.com/backend/login
        //const resp = await fetch("https://conexmetsclm.com/sclm/login", requestOptions)
        //const resp = await fetch("https://conexmetsclm.com/backend/login", requestOptions)
        const resp = await fetch("https://conexmetsclm.com/backend/index.php/login", requestOptions)
                .then(response =>
                            response.json().then(data => ({
                            data: data,
                            status: response.status
                            })
                            )
                    );         
        
            //.then(response => response.json())
            //.then(result => console.log(result))
            //.catch(error => console.log('error', error));
            console.log (resp)

        


            if (resp.data.error)
            {
                //console.log(resp.data.msg)
                new Swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `${resp.data.msg}`,
                    allowOutsideClick: false
                    })
                return { ok: false, message: resp.data.msg, status: resp.data.status }
            } else{
         
                const idToken = resp.data.token
                user.id = resp.data.usuario.operador_id
                user.perfil = resp.data.usuario.tipo
                //console.log(idToken)
                console.log(user)
                //idToken = 
                // TODO : Mutation
                commit('loginUser', { user, idToken})
                return { ok: true, message: resp.data.message , status: resp.data.status }
            }
       
        
    } catch (error) {
        console.log( '3')
        console.log( error)
        console.log( '3')

        new Swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Error en la conexión al server!',
            allowOutsideClick: false
            })


        return { ok: false , message: 'Error en la conexión al server' , status:'0'}
        
    }

}

export const checkAuthentication = async ({ commit }) => {

    const idToken = localStorage.getItem('idToken')

    console.log( 'checkAuthentication')
    //console.log(idToken)

    if ( !idToken ){
        commit('logout')
        return {ok: false, mensaje: 'No hay token en la peticion '}
    }


    try{


        
        // const params =  {    
        //     token : idToken
        // }
        // const options = {
        //     method: 'POST',
        //     body: JSON.stringify( params ),    
        //     headers: {
        //       "Content-type": "application/x-www-form-urlencoded",
        //     }  
        // };

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        const urlencoded = new URLSearchParams();
        urlencoded.append("token", idToken);
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            //body : JSON.stringify({ "token": idToken}),
            redirect: 'follow'
        };
        // usuario : 'CJ900024874',
        // password : 'abc123'
        // CJ900024800
        const resp = await fetch("https://conexmetsclm.com/backend/index.php/valid-token", requestOptions)
            .then(response =>
                    response.json().then(data => ({
                    data: data,
                    status: response.status
                    })
                    )
            );

            

            if (resp.data.status != 200 ){
                //console.log( '11111')
                //console.log(resp.data)
                //console.log(resp.data.msg)
                return { ok: false, message: resp.data.msg, status: resp.data.status }
            } else{
                //console.log(idToken)

                const user = {
                    name: resp.data.msg.nombre

                }

                user.id= localStorage.getItem('idUser')
                user.perfil= localStorage.getItem('idPerfil')            
                //console.log(resp.data)
                 // TODO : Mutation
                commit('loginUser', { user, idToken})
                return { ok: true, message: resp.data.message , status: resp.data.status }
            }


    }catch(error)
    {
        commit('logout')
        return {ok: false, mensaje: 'Erro del Backend '}   
    }

}